module.exports = __webpack_public_path__ + "media/recipes/102-72fa6b61.png";